import { DetailsList, DetailsListLayoutMode, SelectionMode } from '@fluentui/react';
import React, { useState } from 'react';
import PrimaryButton from '../../../../Forms/PrimaryButton';
import { sharedColumns } from './SharedData';
const customStyles = {
    root: {
        backgroundColor: 'rgb(241 90 94)', // A shade of red for the default state
        color: '#ffffff', // White text color for contrast,
        border:'none'
    },
    rootHovered: {
        backgroundColor: '#a4262c', // A darker shade of red for the hovered state
        color: '#ffffff',
    },
    rootPressed: {
        backgroundColor: '#761e1e', // An even darker shade of red for the pressed state
    },
};
const PotentialWinnersTable = ({ potentialWinners, voidPotentialWinner, markAsWinner, atCapacity }) => {
    const [markedWinners, setMarkedWinners] = useState([]);

    const markAsWinnerWrapper = (item) => {
        setMarkedWinners((current) => [...current, item.userId]);
        markAsWinner(item);
    };

    const voidWinner = (item) => {
        voidPotentialWinner(item);
    };

    const columns = [
        ...sharedColumns,
        {
            key: 'markWinner',
            minWidth: 100,
            maxWidth: 100,
            onRender: (item) => {
                return (
                    <PrimaryButton
                        onClick={() => markAsWinnerWrapper(item)}
                        text={item.voided ? "VOIDED" : "Mark Winner"}
                        disabled={markedWinners.includes(item.userId) || atCapacity || item.voided}
                    />
                );
            },
        },
        {
            key: 'voidWinner',
            minWidth: 100,
            maxWidth: 100,
            onRender: (item) => {
                return (
                    <PrimaryButton
                        onClick={() => voidWinner(item)}
                        text={item.voided ? "VOIDED" : "VOID User (this month only)"}
                        disabled={markedWinners.includes(item.userId) || atCapacity || item.voided}
                        styles={customStyles}
                    />
                );
            },
        },
    ];

    return (
        <DetailsList
            items={potentialWinners}
            columns={columns}
            selectionMode={SelectionMode.none}
            setKey="userId"
            layoutMode={DetailsListLayoutMode.justified}
        />
    );
};

export default PotentialWinnersTable;
